import { createSlice } from "@reduxjs/toolkit";

export const incomeElectionSlice = createSlice({
  name: "incomeElectionReducer",
  initialState: {
    incomeElectionInStore: {},
  },
  reducers: {
    setIncomeElectionInStore: (state, action) => {
      state.incomeElectionInStore = action.payload;
    },
    clearIncomeElectionInStore: (state) => {
      state.incomeElectionInStore = {};
    },
  },
});

export const { setIncomeElectionInStore, clearIncomeElectionInStore } =
  incomeElectionSlice.actions;
export default incomeElectionSlice.reducer;
